export function initSubscriptionButton() {
    const btn = document.getElementById('btn-abo');
    if (!btn) return;

    btn.addEventListener('click', function(e) {
        e.preventDefault();
        const formMail = document.getElementById('input-mail-sub')?.value || '';
        console.log(encodeURIComponent(formMail))
        const url = "https://abonnement.satellifacts.com/index.php?page=abonnement&action=etape_1&id_package=23&NLem=" + encodeURIComponent(formMail);
        window.location.href = url;
    });
}